import { useLatestCallback } from 'hook/useLatestCallback'
import { useRefState } from 'hook/useRefState'
import { RefCallback, useEffect } from 'react'

const isTouchDevice = () => {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch {
    return false
  }
}

type E = HTMLElement

export function useClickOutside<T extends E = E>(callback: () => void): RefCallback<T | null | undefined> {
  const [ref, onRef] = useRefState<T>()

  const listener = useLatestCallback((event: MouseEvent | TouchEvent) => {
    const target = event.target as Node
    if (ref && !ref.contains(target)) callback()
  })

  useEffect(() => {
    const type = isTouchDevice() ? 'touchend' : 'mouseup'
    document.addEventListener(type, listener)
    return () => document.removeEventListener(type, listener)
  }, [listener, ref])

  return onRef
}
